import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from '@epcbuilder/lib/components';
import Layout from '@/components/Layout';

const Complaints = () => {
  return (
    <>
      <Helmet>
        <title>Complaints Handling Procedure</title>
        <meta
          name="description"
          content="Improving your property's value, efficiency, and running costs with home upgrades"
        />
      </Helmet>
      <Layout title="EPC Builder Privacy Policy">
        <div className="bg-primary flex h-48 w-full items-center justify-center">
          <h1 className="text-light text-center text-2xl">Complaints Handling Procedure</h1>
        </div>
        <Container>
          <div className="my-8 flex flex-col gap-4">
            <h2>If you need to make a complaint</h2>
            <p>The principle assigned to deal with complaints is:</p>
            Leyton Kay - Consumer Finance Manager <br />
            Improveasy Ltd <br />
            Station House <br />
            Stamford New Road <br />
            Altrincham <br />
            WA14 1EP <br />
            <p>
              Telephone:{' '}
              <a href="tel:01612507643" className="text-primary">
                0161 250 7643
              </a>
            </p>
            <p>
              Email:{' '}
              <a href="mailto:leyton.kay@improveasy.com" className="text-primary">
                leyton.kay@improveasy.com
              </a>
            </p>
            <a href="https://www.improveasy.com" className="text-primary" target="_blank" rel="noopener noreferrer">
              www.improveasy.com
            </a>
            <br />
            Company Registration No: 07807352 <br />
            FRN: 708623
            <h2>Step-by-step complaints procedure</h2>
            <p>
              If you’re not completely happy with our service we’d like to hear about it so we can do something to put
              it right.
            </p>
            <p>
              We do everything we can to make sure our customers get the best products and service possible. However,
              sometimes we may not get things right the first time.
            </p>
            <p>When that happens, we want you to tell us what went wrong so we can put matters right. </p>
            <p>We want to:</p>
            <ul className="ml-8 list-disc">
              <li>Make it easy for you to tell us what went wrong</li>
              <li>Give your complaint the attention it deserves</li>
              <li>Resolve your complaint fairly without delay</li>
              <li>Make sure you are satisfied with how your complaint was resolved</li>
            </ul>
            <h2>How and where to complain</h2>
            <p>
              If you are not satisfied with any aspect of our service or products you can tell us about your complaint
              in the following ways:{' '}
            </p>
            <p>
              <strong>In person</strong> – call into our office at the address shown. We are open Monday to Friday from
              9.00 am – 5.00pm.
            </p>
            <p>
              <strong>In writing</strong> – write to us and address your letter to The Customer Complaint Manager.
            </p>
            <p>
              <strong>By telephone</strong> – call us on{' '}
              <a href="tel:01612507643" className="text-primary">
                0161 250 7643
              </a>{' '}
              during our office hours and ask for the Customer Services Department.
            </p>
            <p>
              <strong>By email</strong> – use the email address shown.
            </p>
            <h2>How long will it take?</h2>
            <p>
              We aim to resolve your complaint straightaway but if we can’t, then we will write to you within three
              business days to tell you:
            </p>
            <ul className="ml-8 list-disc">
              <li>Why we have not resolved your complaint</li>
              <li>Who is dealing with your complaint</li>
              <li>When we will contact you again</li>
            </ul>
            <p>We will aim to resolve your complaint quickly but it may take longer if it is complex.</p>
            <p>
              We will keep you informed on a regular basis but if you need an update please call us on{' '}
              <a href="tel:01612507643" className="text-primary">
                0161 250 7643
              </a>{' '}
              and ask to speak to the person handling your complaint.
            </p>
            <h2>If we cannot reach agreement with you?</h2>
            <p>If we can’t agree a solution with you within eight weeks, we will:</p>
            <ul className="ml-8 list-disc">
              <li>
                Send a letter giving our reasons for the delay and an indication of when we expect to provide a final
                decision.
              </li>
              <li>Issue our final decision letter which will explain our final position</li>
            </ul>
            <h2>The Financial Ombudsman Service</h2>
            <p>
              Our aim is to resolve all complaints internally. However, if after receiving our final decision letter, or
              if eight weeks have passed (this is sometimes referred to as the “eight-week rule”), you may have the
              right to refer your complaint to the Financial Ombudsman Service (FOS). The eight weeks start from the
              date a complaint is received anywhere in our business. Their contact details are shown below.
            </p>
            <p>
              <strong>Please note:</strong> Only complaints relating to the sale of financial services should be
              referred to FOS.
            </p>
            <h2>Financial Ombudsman Service can be contacted in writing:</h2>
            <p>
              Financial Ombudsman Service <br />
              Exchange Tower <br />
              London E14 9SR
            </p>
            <p>
              Telephone: <br />
              <a href="tel:08000234567" className="text-primary">
                0800 023 4567
              </a>{' '}
              (free for most people ringing from a fixed line) <br />
              <a href="tel:03001239123" className="text-primary">
                0300 123 9123
              </a>{' '}
              (cheaper for those calling using a mobile) <br />
              <a href="tel:442079640500" className="text-primary">
                +44 20 7964 0500
              </a>{' '}
              (if calling from abroad)
            </p>
            <p>
              Email:{' '}
              <a href="mailto:complaint.info@financial-ombudsman.org.uk" className="text-primary">
                complaint.info@financial-ombudsman.org.uk
              </a>
            </p>
            <p>
              Further information can be obtained from the Financial Ombudsman Service’s website at:{' '}
              <a
                href="https://www.financial-ombudsman.org.uk"
                className="text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.financial-ombudsman.org.uk
              </a>
            </p>
            <img
              src="/images/fos-logo-horizontal.png"
              alt="Financial Ombudsman Services Logo"
              className="w-48 items-center"
            />
            <p>
              If you are not satisfied with any aspect of our service or products relating to your finance agreement,
              please tell us about your complaint.
              <br />
              <br />
              Contact: <br />
              Leyton Kay - Consumer Finance Manager <br />
              <p>
                Telephone:{' '}
                <a href="tel:01612507643" className="text-primary">
                  0161 250 7643
                </a>
              </p>
              <p>
                Email:{' '}
                <a href="mailto:leyton.kay@improveasy.com" className="text-primary">
                  leyton.kay@improveasy.com
                </a>
              </p>
            </p>
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default Complaints;
